<template>
    <page-common type="normal" :showAppTopLink="isSharePage" :showAppBotLink="isSharePage" :detail="data">
        <div class="theme">
            <div class="theme__top">
                <div class="theme_header">
                    <img class="bg_header_img"
                        :style="'background:#F6F6F6'"
                        v-if="data.headImage"
                        :src="data.headImage"
                        @load="loadImg"
                    />
                    <div class="theme_header_tip">
                        <span class="tip">#话题</span>
                        <span class="number">{{data.hits}}<span class="num_tip">人参与讨论</span></span>
                    </div>
                    
                </div>
            </div>
            <!-- <div 
                class="head-banner" 
                v-if="data.headImage "
                :style="{ 'background-image': `url( ${data.headImage} )` }"
            >
               
                <div class="head-banner__info">
                    <i class="label">话题</i>{{data.hits}}人参与讨论
                </div>
            </div> -->
            <!-- 标题区 -->
            <div class="title-area">
                <h3>{{data.viewType=='bigimage' ? (data.showTitle?data.title:'') : (data.showTitle?data.listTitle:data.title) }}</h3>
                <div class="description_content">
                    <div 
                        :class="isHideDescFlag?'description mult_line_ellipsis':'description'" 
                        v-html="data.description&&data.description.replace(/(\r\n|\n|\r)/gm, '<br />')">
                    </div>
                    <div :class="isHideDescFlag?'unfold':'fold'" v-if="isNeedUnfold" @click="unfold">{{unfoldText}} <span class="arrow-down"></span></div>
                </div>
            </div>
            <PageVote v-if="data.hasVote" :voteObj="data"></PageVote>
             <div class="list">            
                <theme-list :sysCode="data.sysCode" @on-openApp="openDialog"></theme-list>
            </div>
        </div>
    </page-common>
</template>
<script>
import { MessageBox } from 'mint-ui';
import wx from '../services/weChatShare'
import api from 'src/constants/appapi'
import PageCommon from './page-common'
import PageVote from './page-vote.vue'
import { intfc_prefix_common } from 'constants/project'
import themeList from './news_stream/theme-list'
import dialogComponent from './dialog';
import titleIcon from 'src/images/vote_icon.png'
export default {
    components:{
        PageCommon,
        themeList,
        dialogComponent,
        PageVote
    },
    data(){
        return {
            titleIcon,
            isNeedUnfold: false,
            isHideDescFlag: false,
            unfoldText: "展开",
            isSharePage:false,
            data:{},
            errorUserPhoto: '',
            vodeOption:{},
			isShowDialog: false,
			dialogParams: {},
        }
    },
    watch: {
        'data'(newVal, oldVal) {
            if(newVal.id && newVal.id !== oldVal.id) {
                this.formatDesc()
            }
        }
    },
    created(){
          // 暴露方法给webview
        window.appapi = api
        window.$vm = this
        const themeId = this.$route.params.id
        this.getInit(themeId)
        //this.getComment(themeId)
        this.isSharePage = appapi.isSharePage()
        console.log(this.isSharePage )
    },
    mounted() {
       
    },
    methods: {
        // handleVote() {
        //     MessageBox.confirm('即将离开当前页面，打开“人民网+”客户端?').then(action => {
        //         // console.log('action', action)
        //         if(action == "confirm"){
        //             console.log('action', action)
        //             $('a#openApp')[0].click()
        //         }
        //     }).catch((res)=>{
        //         console.log('取消res', res)
        //     });
        // },
        formatDesc() {
            this.$nextTick(function() {
                // 计算内容高度，设置展开全文
                const DescEl = this.$el.querySelector('.title-area .description');
                const DescH = DescEl.offsetHeight;
                const finalStyle = DescEl.currentStyle ? DescEl.currentStyle : window.getComputedStyle(DescEl, null)
                // console.log(finalStyle.height,finalStyle.lineHeight)
                if(parseInt(finalStyle.height) > parseInt(finalStyle.lineHeight)* 5){
                    this.isNeedUnfold = true
                    this.isHideDescFlag = true
                }
            });
        },
        unfold() {
            this.isHideDescFlag = !this.isHideDescFlag;
            this.unfoldText = this.unfoldText === '展开' ? '收起' : '展开';
        },
        loadImg(e) {
          e.target.style.backgroundImage = 'unset'
        },
        getInit(themeId){
            this.$axios.get(`${intfc_prefix_common}/api/v2/articles/detail/${themeId}`)
                .then(res=>{
                    if(res.code ==0){
                        this.data = res.item
                        const result = res.item
                        const desc = result.description ? result.description : ''
                        wx({
                            title: result.listTitle || result.title,
                            desc,
                            imgUrl: result.shareImage || '',
                        },this)
                        if(this.data.hasVote){
                            this.getVote(this.data.voteId)
                        }
                    }
                })
        },
        getVote(voteId){ //投票接口
            this.$axios.get(`${intfc_prefix_common}/api/v2/vote/getVoteInfo/${voteId}`)
                .then(res=>{
                    if(res.code ==0){
                        this.vodeOption = res.item
                        let n = 0
                        this.vodeOption.options.map((item)=>{
                            if(item.imageUrl) n++
                        })
                        if(n!=0){
                            this.vodeOption.options.map((item)=>{
                              if(!item.imageUrl){
                                    this.$nextTick(function() {
                                        // 计算内容高度，设置展开全文
                                        const item = this.$el.querySelectorAll('.ballot-list .noimageUrl');
                                        console.log(item,'item')
                                        for(let i=0;i<item.length;i++){
                                          item[i].style.height="1rem";
                                        }
                                    });
                              }  
                            })
                        }
                        if(n==0){
                            this.vodeOption.options.map((item)=>{
                                if(item.title.length>16){
                                    this.$nextTick(function() {
                                        // 计算内容高度，设置展开全文
                                        const item = this.$el.querySelectorAll('.ballot-list .item');
                                        for(let i=0;i<item.length;i++){
                                            item[i].style.height="1rem";
                                        }
                                    });
                                }
                            })
                        }
                    }
                })
        },
        goLast(){
            this.$router.push('/lastTheme')
		},
		// 打开弹窗
		openDialog(options){
            console.log("rerere")
			this.isShowDialog = true;
			this.dialogParams = {
				articleId:this.data.id,
				categoryId:this.data.categoryId,
				sysCode:this.data.sysCode||"",
				type:this.data.type || this.data.sysCode || "",
				link:this.data.link|| ""
        	}
		},
		// 关闭弹窗
        closeDialog(){
			this.isShowDialog = false
		},
		// 确定
		okDialog(){
			this.isShowDialog = false;
		}
    }
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
    @import "~src/stylus/mixin";
    .head-banner   
        position relative; 
        height 0;
        padding-top: 72%;
        background: #333333  top/cover;
        z-index 0;
        .head-banner__info
            position absolute
            left 0
            right 0
            bottom 0px
            z-index: 9;
            padding: 110px 30px 0;
            height 90px
            color #FFFFFF;
            font-size: 24px;
            line-height: 44px;
            background linear-gradient(180deg, rgba(0,0,0,0.00) 0%, rgba(0,0,0,0.70) 100%)
            i.label
                display inline-block;
                height 48px;
                padding 0 20px;
                border-radius 24px 0 24px 0
                background-color #DF542F 
                font-size: 24px;
                color: #FFFFFF;
                line-height: 48px;
                margin-right 18px;
    .img-frame-small
        margin 0 0px 0px
        height 115px
        position relative
        overflow hidden
        .img-bac
            width 100%
            height 100%    
            background-size cover !important
            background-position center center !important
            position relative
            font-family: 'FZBIAOYSK','FZBIAOYSKIOS','FZBIAOYSKIOS BOLD', 'PingFangSC-Regular', '微软雅黑', sans-serif;
    .top-pic
        position relative
        width 750px
        max-height 469px
        overflow hidden
        img
            width 100%
            display block
        .pic-blur
            width: 100%;
            background-repeat: no-repeat;
            background-position: center;
            background-size: cover;
            -webkit-filter: blur(15px);
            -moz-filter: blur(15px);
            -o-filter: blur(15px);
            -ms-filter: blur(15px);
            filter: blur(15px);
        .pic-blur-img
            position absolute
            left 60px
            bottom 20px
            width 226px
            height 170px
    .title-area
        // margin-top 32px
        padding 0 30px
        h3 
            line-height 62px 
            color #222
            font-size 44px
        .description_content
            margin-top 28px
            background: #f9f9f9;
            padding:30px;
        .description 
            font-size 28px;
            color: #222222;
            line-height 46px
            text-align justify;
            &.mult_line_ellipsis 
                overflow hidden
                text-overflow ellipsis //文本溢出显示省略号
                display: -webkit-box
                -webkit-line-clamp 5
                -webkit-box-orient vertical

        .unfold,.fold
            text-align right;
            color: #999999
            font-size: 24px;
            line-height: 52px;
            span.arrow-down 
                border-left: 2px solid #999999;
                border-bottom: 2px solid #999999;
                height: 8px;
                width: 8px;
                transform: translate(2px, -6px) rotate(-45deg);
                -webkit-transform: translate(2px, -6px) rotate(-45deg);
                border-right: 2px solid transparent;
                border-top: 2px solid transparent;
                display: inline-block;
                -moz-transform: translate(2px, -6px) rotate(-45deg);
                -ms-transform: translate(2px, -6px) rotate(-45deg);
                -o-transform: translate(2px, -6px) rotate(-45deg);
        .fold span.arrow-down
            transform: translate(2px, 2px) rotate(135deg);
            -webkit-transform: translate(2px, 2px) rotate(135deg);
            border-right: 2px solid transparent;
            border-top: 2px solid transparent;
            display: inline-block;
            -moz-transform: translate(2px, 2px) rotate(135deg);
            -ms-transform: translate(2px, 2px) rotate(135deg);
            -o-transform: translate(2px, 2px) rotate(135deg);

    .ballot
        margin: 32px 0px 0;
        // padding: 20px;
        .ballot-title
            font-size: 36px;
            line-height: 48px;
            font-weight: bold;
            color: #333641;
            // background: url("~images/vote_icon.png") left top/60px  no-repeat;
            // background-position-y: 8px;
            img 
                width: 56px;
                height: 32px;
                margin-right 20px
        .ballot-list .item
            margin-top: 18px;
            padding: 10px;
            // background: #FFFFFF;
            border: 2px solid #e1e4ea;
            border-radius: 6px;
            text-align: center;
            font-size: 32px;
            color: #999;
            line-height 38px;
            display: flex;
            .itemImg
                width 240px;
                height 140px;
                margin-right 20px;
                border-radius: 8px;
                img 
                    width 100%;
                    height 100%;
            .item-bg 
                background #edf4fe
            .item-title
                // justify-content: center;
                align-items: center;
                display: flex;
                width 80%;
            .item-percentage
                width 20%
                display: flex;
                justify-content: center;
                align-items: center;
            span 
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
        
            
    .top-block-title
        margin: 0;
        font-size: 36px;
        font-weight: 500;
        color: #333333;
        line-height: 50px;
        i.icon-block 
            display inline-block
            margin: 0 20px 0 0px
            padding 0 9px
            font-size: 36px;
            width: 0px;
            height: 42px;
            background: #DF542F;
    .theme
        //background #D8D8D8
        // height: 100vh;
        // overflow scroll
        .theme__top
            // background #fff
            .theme__bg 
                // background: #FFDA75 url("~images/theme_bg.png") no-repeat center top
                background-size: 100%
                position: relative;
                border-radius 20px
                overflow hidden
                &:before
                    content ''
                    display block
                    position absolute
                    top 50%
                    left -18px;
                    width: 36px;  
                    height: 36px;  
                    line-height: 36px;  
                    text-align: center;   
                    background-color: #fff;  
                    border-radius 100%
                &:after
                    content ''
                    display block
                    position absolute
                    top 50%
                    right -18px;
                    width: 36px;  
                    height: 36px;  
                    line-height: 36px;  
                    text-align: center;   
                    background-color: #fff;  
                    border-radius 100%
                .icon_theme
                    display inline-block
                    margin 40px 0 26px 162px 
                    width 122px
                    height 48px
                .theme__description
                    position relative
                    color:#4E1312
                    font-size:32px;
                    line-height:44px;
                    width: 460px;
                    margin: 0 44px 120px 162px ;
                    font-weight bold
                .theme__join
                    border-radius 26px
                    // background url("~images/icon_user_theme.png") no-repeat 20px center / 48px 48px
                    background-color #F28D0B;
                    padding: 14px 34px 14px 40px;
                    color: #fff;
                    position: absolute;
                    font-size: 24px;
                    bottom 30px;
                    right:34px;
                    .theme__join__user
                        margin-left 40px

            .theme_header
                .bg_header_img
                    width 100%
                    height 375px
                    object-fit cover
                    background-size cover !important
                    background-position center !important
                .theme_header_tip
                    padding:30px;
                    .tip
                        background: linear-gradient(194deg,#ff4d40 8%, #f52d2d 81%);
                        font-size: 26px;
                        color: #ffffff;
                        padding: 5px 12px;
                        text-align center;
                        line-height 40px;
                    .number
                        font-size 20px;
                        color: #666666;
                        margin-left:20px;
                    .num_tip
                        padding-left:10px;
                .description
                    color #333
                    font-size 32px
                    line-height 56px
                    padding 50px
                    font-weight normal
                    text-align center
                .theme_header_content
                    margin-top 10px
                    padding 0px 20px 50px
                    .title
                        color #333333
                        font-size 32px
                        line-height 44px
                        font-weight 600
                    .subTitle
                        font-size 28px
                        color #222
                        margin 20px 0
                    .user
                        color #666
                        margin-top 28px
                        // background url("~images/icon_user_theme2.png") no-repeat 0px center / 48px 48px
                        span
                            margin-left 54px
                            font-size 24px
                            line-height 40px
                    .vote-container
                        margin-top 38px
                    
            .btn_more
                display: block;
                margin: 0 auto;
                width: 100%;
                text-align: center;
                padding: 0px 0 56px 0;
                width 294px
                height 72px
                img 
                    width 100%
                    height 100%
        .bg_Topic_f
            // background url("~images/bg_Topic_f.png") no-repeat
            background-size 100%
            height 18px
        .list
            background: #fff;
            margin-top 32px
            // margin-top 30px
	.dialog_publish_main
		font-family: PingFangSC-Medium;
		font-size: 36px;
		color: #222222;
		letter-spacing: 0;
		text-align: center;
.btn-ok
    background: #d2494a;
    border-radius: 36px;
    color:#fff;
    font-size: 32px;
    width: 276px;
    height: 72px;
    text-align center
    line-height 72px
    margin-top: 40px
    justify-content: center;
    margin: 0.533rem auto 0 auto;
</style>


// WEBPACK FOOTER //
// page-theme.vue?12252f08